const ADM_KEY = '@CondomobWeb:adm';

export const storeAdm = (value) => sessionStorage.setItem(ADM_KEY, value);

export const removeAdm = () => sessionStorage.removeItem(ADM_KEY);

export const getAdm = () => sessionStorage.getItem(ADM_KEY);
